export default __webpack_public_path__ + "static/media/about3title2.48850825.png";